/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { HomeHealthPractitionerAssignmentPractitioner } from './HomeHealthPractitionerAssignmentPractitioner';
import {
    HomeHealthPractitionerAssignmentPractitionerFromJSON,
    HomeHealthPractitionerAssignmentPractitionerFromJSONTyped,
    HomeHealthPractitionerAssignmentPractitionerToJSON,
    HomeHealthPractitionerAssignmentPractitionerToJSONTyped,
} from './HomeHealthPractitionerAssignmentPractitioner';
import type { HomeHealthPractitionerRole } from './HomeHealthPractitionerRole';
import {
    HomeHealthPractitionerRoleFromJSON,
    HomeHealthPractitionerRoleFromJSONTyped,
    HomeHealthPractitionerRoleToJSON,
    HomeHealthPractitionerRoleToJSONTyped,
} from './HomeHealthPractitionerRole';
import type { PecosVerification } from './PecosVerification';
import {
    PecosVerificationFromJSON,
    PecosVerificationFromJSONTyped,
    PecosVerificationToJSON,
    PecosVerificationToJSONTyped,
} from './PecosVerification';

/**
 * 
 * @export
 * @interface HomeHealthPractitionerAssignment
 */
export interface HomeHealthPractitionerAssignment {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    practitioner_id: string;
    /**
     * 
     */
    updated_at: Date;
    /**
     * 
     */
    role: HomeHealthPractitionerRole | null;
    /**
     * 
     */
    effective_date?: string | null;
    /**
     * 
     */
    source_document?: string | null;
    /**
     * 
     */
    practitioner: HomeHealthPractitionerAssignmentPractitioner;
    /**
     * 
     */
    pecos_verification?: PecosVerification;
    /**
     * 
     */
    last_checked_at: string | null;
}



/**
 * Check if a given object implements the HomeHealthPractitionerAssignment interface.
 */
export function instanceOfHomeHealthPractitionerAssignment(value: object): value is HomeHealthPractitionerAssignment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('practitioner_id' in value) || value['practitioner_id'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('practitioner' in value) || value['practitioner'] === undefined) return false;
    if (!('last_checked_at' in value) || value['last_checked_at'] === undefined) return false;
    return true;
}

export function HomeHealthPractitionerAssignmentFromJSON(json: any): HomeHealthPractitionerAssignment {
    return HomeHealthPractitionerAssignmentFromJSONTyped(json, false);
}

export function HomeHealthPractitionerAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthPractitionerAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'practitioner_id': json['practitioner_id'],
        'updated_at': (json['updated_at'] == null ? json['updated_at'] : parseDateTime(json['updated_at'])),
        'role': HomeHealthPractitionerRoleFromJSON(json['role']),
        'effective_date': json['effective_date'] === undefined ? undefined : json['effective_date'] === null ? null : json['effective_date'],
        'source_document': json['source_document'] === undefined ? undefined : json['source_document'] === null ? null : json['source_document'],
        'practitioner': HomeHealthPractitionerAssignmentPractitionerFromJSON(json['practitioner']),
        'pecos_verification': json['pecos_verification'] == null ? undefined : PecosVerificationFromJSON(json['pecos_verification']),
        'last_checked_at': json['last_checked_at'],
    };
}

export function HomeHealthPractitionerAssignmentToJSON(json: any): HomeHealthPractitionerAssignment {
    return HomeHealthPractitionerAssignmentToJSONTyped(json, false);
}

export function HomeHealthPractitionerAssignmentToJSONTyped(value?: HomeHealthPractitionerAssignment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'practitioner_id': value['practitioner_id'],
        'updated_at': value['updated_at'] == null ? value['updated_at'] : serializeDateTime(value['updated_at']),
        'role': HomeHealthPractitionerRoleToJSON(value['role']),
        'effective_date': value['effective_date'],
        'source_document': value['source_document'],
        'practitioner': HomeHealthPractitionerAssignmentPractitionerToJSON(value['practitioner']),
        'pecos_verification': PecosVerificationToJSON(value['pecos_verification']),
        'last_checked_at': value['last_checked_at'],
    };
}

